import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ZoomWriterForm from '../forms/zoom-writer-form';
import { zoomWriterValidationSchema } from '../schema/zoomWriter.js';

export default function ZoomWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Zoom Writer Node Details',
        altText: 'Zoom Writer Node',
        defaultLabel: 'Zoom Writer Node',
      }}
    >
      <CommonNode FormComponent={ZoomWriterForm} schemaResolver={zoomWriterValidationSchema} />
    </NodeProvider>
  );
}
